import SearchWatchListEntriesByWatchListForm from './SearchWatchListEntriesByWatchListForm';

export default SearchWatchListEntriesByWatchListForm;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-entries-by-watch-list-form/index.js